export default __webpack_public_path__ + "static/media/bag-open.74ac7328.png";